<template>
  <div class="aaa">
    <div class="breadcrumb">
      <div class="breadcrumb-box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }" v-if="title == undefined || title == '' || title == 'undefined' || title == null || name == ''">
            <div class="breadcrumb-item">
              <img src="../assets/images/breadcrumb_icon_home.png" class="icon-home" />
              <span class="breadcrumb-text">Главная</span>
            </div>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="href"
            >выбранное место:
            <span>{{ title }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="name != '' && name != null && name != undefined">{{ name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: '',
    name: '',
    href: '',
  },
  created() {
    console.log(this.title);
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
/deep/.el-breadcrumb__inner {
  color: #e9ad61 !important;
  // font-weight: bold;
}
/deep/.el-breadcrumb__separator {
  color: #e9ad61 !important;
  // font-weight: 400;
  margin: 0;
}
/deep/.el-breadcrumb__inner {
  font-weight: bold !important;
  cursor: pointer;
}
// /deep/.el-breadcrumb__inner
// /deep/.el-breadcrumb__separator {
//   display: none;
// }
.aaa {
  height: 37px;
}
.breadcrumb {
  width: 100%;
  padding: 10px 0;
  background-color: #fff7ec;
  position: fixed;
  z-index: 99;
  &-box {
    width: 1200px;
    margin: 0 auto;
    .icon-home {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
  &-text {
    font-size: 14px;
    color: #e9ad61;
    margin-bottom: 3px;
    vertical-align: middle;
  }
  &-item {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }
}
</style>
